<script>
import _ from 'lodash';
import Storage from 'Shared/helpers/storageManager';
import responsiveMixin from '@/mixins/responsiveMixin';
import { SHOW_SNACKBAR } from '@/store/types';
import { helpers as notificationHelpers } from '@/store/modules/notifications';
import { helpers as referralHelpers } from '@/store/modules/referral';
import ParticipantSignupEmail from './ParticipantSignupEmail';
import Facebook from './thirdPartySignups/Facebook';
import Linkedin from './thirdPartySignups/Linkedin';
import Alert from 'Shared/styleguide/alert.vue'
import * as Segment from '@/utils/segment';

export default {
  components: {
    Facebook,
    Linkedin,
    ParticipantSignupEmail,
    Alert
  },
  mixins: [responsiveMixin],
  data() {
    const organizationId = this.getFromRouteOrStorage(
      'organizationId',
      Storage.respondentOrganizationId
    );
    const teamId = this.getFromRouteOrStorage(
      'teamId',
      Storage.respondentTeamId
    );
    const projectId = Storage.respondentReferralProject.get();
    const { inviteCode } = this.getInviteFromRouteOrStorage();
    const showPublicApiAlert = window?.APP_CONFIG?.APP_ENV !== 'PRODUCTION'

    return {
      inviteCode,
      organizationId,
      projectId,
      teamId,
      showPublicApiAlert,
      apiDocsUrl: 'https://developers.respondent.io/reference/profilescontroller_create',
    };
  },
  computed: {
    ...referralHelpers.mapState({
      referrerName: 'referrerName',
      referralCode: 'referralCode',
    }),
    headerText() {
      if (_.isEmpty(this.referrerName))
        return 'Create a New Participant Account';
      return `${this.referrerName} has invited you to join Respondent`;
    },
    desktopHeaderDisplaySize() {
      if (_.isEmpty(this.referrerName)) return 'display-4';
      return 'display-3';
    },
    authError() {
      return this.$route.query?.authError
    },
    projectRedirect() {
      return this.$route.query?.projectId
    }
  },
  methods: {
    ...notificationHelpers.mapActions({ showSnackbar: SHOW_SNACKBAR }),
    getInviteFromRouteOrStorage() {
      const storageInvite = Storage.respondentInvite.getObject();
      const { inviteId, invite: inviteCode } = this.$route.query;
      if (inviteId) Storage.respondentInvite.setInObject('id', inviteId);
      if (inviteCode) Storage.respondentInvite.setInObject('code', inviteCode);

      return {
        inviteId: inviteId || storageInvite.id,
        inviteCode: inviteCode || storageInvite.code,
      };
    },
    getFromRouteOrStorage(routeParam, storageInterface) {
      const value = this.$route.query[routeParam] || storageInterface.get();
      if (value) storageInterface.set(value);
      return value;
    },
    onApiDocs() {
      Segment.track('Participant_Signup_ApiDocsViewd');
      window.open(this.apiDocsUrl, '_blank');
    }
  },
  mounted(){
    if(this.authError){
      this.showSnackbar({ message: this.authError});
    }
    if(this.projectRedirect){
      Storage.redirect.setInObject('survey',{
          name: 'Project',
          params: { id: this.projectRedirect },
        })
    }
  }
};
</script>

<template>
  <div style="max-width: 530px">

    <alert type="danger" v-if="this.showPublicApiAlert">
      <template v-slot:header>
        API Partners
      </template>
      <template v-slot:content>
          If you are building on our Recruiting API and looking to create
          participants for end to end testing, please create all participants
          through our Profiles POST endpoint.
      </template>
      <template v-slot:actions>
        <button class="btn" @click="onApiDocs()">API Docs</button>
      </template>
    </alert>

    <h1 :class="responsiveClasses({
      tablet: 'display-3 mb-4',
      desktop: `${desktopHeaderDisplaySize} mb-5`,
    })
      ">
      {{ headerText }}
    </h1>

    <p class="mb-11">
      Get paid for sharing valuable insights and help shape world-class
      products.
    </p>

    <participant-signup-email class="mb-6" />

    <linkedin class="mb-5" :organization-id="organizationId" :project-id="projectId" :referral-code="referralCode"
      :team-id="teamId" />

    <facebook :invite-code="inviteCode" :organization-id="organizationId" :project-id="projectId"
      :referral-code="referralCode" :team-id="teamId" class="mb-10" />
  </div>
</template>
